import { type IApplicationContext } from '@/app/shared/types/ApplicationContext';

import { BrowserQueryState } from '@/packages/query-state/shared/services/QueryState';
import { BrowserReduxState } from '@/packages/redux-state/ReduxState';

import { renderApplication } from '../renderApplication';

export function runApp(context: IApplicationContext): void {
  const browserQueryState = new BrowserQueryState(context);
  const browserReduxState = new BrowserReduxState(context);

  renderApplication({
    reduxState: browserReduxState,
    context,
    queryState: browserQueryState,
  });
}
